/**
 * Serialize a JSON-LD object for safe embedding inside a
 * <script type="application/ld+json"> block.
 *
 * JSON.stringify does NOT escape `<`, `>`, or `&`, so catalog- or
 * admin-controlled values (product titles, descriptions, SKUs, category names)
 * could break out of the script element (`</script><script>...`) or open an
 * HTML comment (`<!--`) — a stored-XSS vector. Escaping these three code points
 * to their `\uXXXX` form keeps the output valid JSON-LD while making it
 * impossible to terminate the script tag or be parsed as HTML. (U+2028/U+2029
 * only need escaping when JSON is inlined into an executable JS string literal,
 * which a `type="application/ld+json"` data block is not.)
 */
export function jsonLd(data: unknown): string {
  return JSON.stringify(data)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
}
